var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98058 19.5548H4.30615V15.9209H7.98058V19.5548ZM5.09647 18.7731H7.19027V16.7025H5.09647V18.7731Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8353 19.5548H16.1611V15.9209H19.8353V19.5548ZM16.9514 18.7731H19.045V16.7025H16.9514V18.7731Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89926 5.48542H4.2251V1.85156H7.89952L7.89926 5.48542ZM5.01541 4.7038H7.10921V2.63318H5.01541V4.7038Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6412 5.48542H8.96704V1.85156H12.6415L12.6412 5.48542ZM9.75735 4.7038H11.8512V2.63318H9.75735V4.7038Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89926 10.1751H4.2251V6.54102H7.89952L7.89926 10.1751ZM5.01541 9.39352H7.10921V7.3229H5.01541V9.39352Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6412 10.1751H8.96704V6.54102H12.6415L12.6412 10.1751ZM9.75735 9.39352H11.8512V7.3229H9.75735V9.39352Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89926 14.8656H4.2251V11.2314H7.89952L7.89926 14.8656ZM5.01541 14.0839H7.10921V12.0133H5.01541V14.0839Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6412 14.8656H8.96704V11.2314H12.6415L12.6412 14.8656ZM9.75735 14.0839H11.8512V12.0133H9.75735V14.0839Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.754 10.1751H16.0798V6.54102H19.754V10.1751ZM16.8701 9.39352H18.9637V7.3229H16.8701V9.39352Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.754 14.8656H16.0798V11.2314H19.754V14.8656ZM16.8701 14.0839H18.9637V12.0133H16.8701V14.0839Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8567 23.0596V4.70379H14.7613V0.131836H2.11629V23.0596H0.658691V23.8412H9.04812H12.7225H23.3143V23.0596H21.8567ZM21.0664 5.48541V23.0596H14.7613V5.48541H21.0664ZM9.83843 23.0596V16.7026H11.9322V23.0596H9.83843ZM9.04812 15.921V23.0596H2.9066V0.913455H13.971V23.0596H12.7225V15.921H9.04812Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.2547eb7f5730d7008ed0ad9a7053e209.svg";
export { ForwardRef as ReactComponent };